if (!customElements.get('store-locator-section')) {
  customElements.define('store-locator-section', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.cards = Array.from(this.querySelectorAll('.store-card'));
      this.searchInput = this.querySelector('[data-search-input]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.totalCount = this.querySelector('[data-total-count]');
      this.showingCount = this.querySelector('[data-showing-count] span');
      this.noResults = this.querySelector('[data-no-results]');

      this.initOuterCarousel();
      this.initImageCarousels();
      this.initSearch();
    }

    initOuterCarousel() {
      if (!this.prevBtn || !this.nextBtn || !this.track) return;

      const scrollByCard = (direction) => {
        const card = this.track.querySelector('.store-card:not([hidden])');
        if (!card) return;
        const distance = (card.offsetWidth + 20) * direction;
        this.track.scrollBy({ left: distance, behavior: 'smooth' });
      };

      this.prevBtn.addEventListener('click', () => scrollByCard(-1));
      this.nextBtn.addEventListener('click', () => scrollByCard(1));

      let scrollTimer;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollTimer);
        scrollTimer = requestAnimationFrame(() => this.updateArrows());
      }, { passive: true });

      new ResizeObserver(() => this.updateArrows()).observe(this.track);
      this.updateArrows();
    }

    updateArrows() {
      if (!this.track || !this.prevBtn || !this.nextBtn) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      this.prevBtn.hidden = scrollLeft <= 5;
      this.nextBtn.hidden = scrollLeft >= scrollWidth - clientWidth - 5;
    }

    initImageCarousels() {
      this.querySelectorAll('.store-card-images').forEach(container => {
        const track = container.querySelector('[data-images-track]');
        const dots = container.querySelectorAll('[data-dot-index]');
        if (!track || dots.length === 0) return;

        const slides = track.querySelectorAll('.store-card-slide');
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const index = Array.from(slides).indexOf(entry.target);
              dots.forEach((dot, i) => dot.classList.toggle('active', i === index));
            }
          });
        }, { root: track, threshold: 0.5 });

        slides.forEach(slide => observer.observe(slide));

        dots.forEach(dot => {
          dot.addEventListener('click', () => {
            const index = parseInt(dot.dataset.dotIndex, 10);
            const slide = slides[index];
            if (slide) {
              track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
            }
          });
        });

        this.initDragScroll(track);
      });
    }

    initDragScroll(track) {
      let isDown = false;
      let startX;
      let scrollStart;
      let lastX;
      let velocity = 0;
      let lastTime;

      track.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX;
        lastX = e.pageX;
        scrollStart = track.scrollLeft;
        velocity = 0;
        lastTime = Date.now();
        track.classList.add('is-dragging');
      });

      track.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const now = Date.now();
        const dt = now - lastTime;
        if (dt > 0) {
          velocity = (lastX - e.pageX) / dt;
        }
        lastX = e.pageX;
        lastTime = now;
        track.scrollLeft = scrollStart - (e.pageX - startX);
      });

      const endDrag = () => {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');

        const slideWidth = track.querySelector('.store-card-slide')?.offsetWidth || 1;
        const momentum = velocity * 150;
        const projected = track.scrollLeft + momentum;
        const index = Math.round(projected / slideWidth);
        const clamped = Math.max(0, Math.min(index, track.children.length - 1));

        track.scrollTo({ left: clamped * slideWidth, behavior: 'smooth' });
      };

      track.addEventListener('mouseup', endDrag);
      track.addEventListener('mouseleave', endDrag);
    }

    initSearch() {
      if (!this.searchInput) return;
      let timer;
      this.searchInput.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(() => this.filterStores(), 250);
      });
    }

    filterStores() {
      const term = this.searchInput.value.toLowerCase().trim();
      let visible = 0;

      this.cards.forEach(card => {
        const text = (card.dataset.searchText || '').toLowerCase();
        const match = !term || text.includes(term);
        card.hidden = !match;
        if (match) visible++;
      });

      if (this.showingCount) this.showingCount.textContent = visible;
      if (this.totalCount) this.totalCount.textContent = visible + ' store' + (visible !== 1 ? 's' : '');
      if (this.noResults) this.noResults.hidden = visible > 0;
      if (this.track) this.track.scrollTo({ left: 0 });
      this.updateArrows();
    }
  });
}
